import { useGetIdsHealthcareservicesHcsIdTransmissionsRemaining } from '@toktokdoctech/tokapi-client'
import useCurrentHcs from '../../../hooks/useCurrentHcs'

type UseTransmissionLimitParams = {
    patientId: string
    requiredExpert: {
        id: string
        isHcsEmployee: boolean
    }
}

type TransmissionAlert = {
    title: string | undefined
    text: string
    severity: 'WARNING' | 'INFO'
}

type UseTransmissionLimitRes = {
    isLimitReached: boolean
    isQuotaExhausted: boolean
    alert?: TransmissionAlert
}

export const useTransmissionLimit = ({
    patientId,
    requiredExpert,
}: UseTransmissionLimitParams): UseTransmissionLimitRes => {
    const currentHcs = useCurrentHcs()

    const { data } = useGetIdsHealthcareservicesHcsIdTransmissionsRemaining(
        currentHcs.id,
        {
            patientId,
            requiredExpertId: requiredExpert?.id,
        },
        {
            query: {
                enabled: !!patientId && !!requiredExpert?.id,
            },
        },
    )

    const isLimitReached = !!data?.isLimitReached
    const transmissionsRemaining = data?.transmissionsRemaining
    const isQuotaExhausted = !isLimitReached && transmissionsRemaining === 0

    if (transmissionsRemaining === null || transmissionsRemaining === undefined) {
        return { isLimitReached, isQuotaExhausted, alert: undefined }
    }

    const alert: TransmissionAlert = {
        title:
            data?.transmissionsRemaining && data.transmissionsRemaining < 2
                ? `${data?.transmissionsRemaining} téléexpertise restante`
                : `${data?.transmissionsRemaining} téléexpertises restantes`,
        text:
            isLimitReached || transmissionsRemaining === 0
                ? 'Pour ce duo patient-requis'
                : 'Cet acte sera décompté si facturé',
        severity: isLimitReached ? 'WARNING' : 'INFO',
    }

    return { isLimitReached, isQuotaExhausted, alert }
}
